export const tzjrwUrls = {
  // 审核任务
  ShrwUrls: {
    // 分页查询审核任务
    findPage: '/feather/lcsljdshr/findPage',
    // 修改审核状态
    updateShzt: '/feather/lcsljdshr/updateShzt',
    // 查询审核详情
    findStaRes: '/feather/lcsljdshr/findStaRes',
    // 查询待办流程
    queryToDoFlow: '/workflow/lcsljdshr/queryToDoFlow',
    // 查询已办流程
    queryDoneFlow: '/workflow/lcsljdshr/queryDoneFlow',
    // 查询已发流程
    queryMyYfFlow: '/workflow/lcsljdshr/queryMyYfFlow',
    // 撤回流程
    withdrawalFlow: '/workflow/lcsljdshr/withdrawalFlow',
    // 审核任务
    updateShzts: '/workflow/lcsl/updateShzt',
    // 查询下一节点审核人
    findPageShr: '/workflow/teacherFldlx/findPageShr',
    // 查询流程详情
    findDetail: '/workflow/lcsl/findStaRes',
    // 审核时暂存
    saveAppral: '/workflow/lcsl/saveAppral',
  },
  ZxtzUrls: {
    // 分页查询
    queryInfo: '/tzjrw/receive/getReceives',
    // 查询通知详情
    getDetail: '/tzjrw/receive/getDetail',
    uploadUrl: '/tzjrw/files/uploadFile',
    downloadUrl: '/tzjrw/files/downloadFile',
  },
  // 新建通知urls
  newTzUrls: {
    // 分页查询新建通知
    findNewPage: '/tzjrw/message/findNewPage',
    // 保存通知
    save: '/tzjrw/message/save',
    // 发送通知
    sendMessage: '/tzjrw/message/sendMessage',
    // 删除通知
    deleteById: '/tzjrw/message/deleteById',
    // 查询通知详情
    getDetail: '/tzjrw/message/getDetail',
  },
  // 基础资源url
  jczyUrls: {
    // 分页查询院系信息
    getPageYxxxs: '/tzjrw/zzjg/getPageYxxxs',
    // 查询全部年级信息
    getAll: '/tzjrw/bxnj/getAll',
    // 分页查询所有专业
    findPage: '/tzjrw/zzjgbxzy/findPage',
    // 分页查询所有行政班
    getXzbByPage: '/tzjrw/xzbsz/getXzbByPage',
    // 分页查询教师信息
    getTeachers: '/tzjrw/teacher/getTeachers',
    // 分页查询学生信息
    findXsPage: '/tzjrw/xs/findPage',
    // 分页查询角色信息
    getModules: '/tzjrw/modules/getModules',
  },
  // 通知管理url
  tzglUrls: {
    // 分页查询已发送的通知
    getMessages: '/tzjrw/message/getMessages',
    // 查询通知详情
    getDetail: '/tzjrw/message/getDetail',
    // 撤回通知
    withdrawMessage: '/tzjrw/message/withdrawMessage',
  },
  // 我的通知
  myMessageUrls: {
    // 分页查看接收到的通知列表
    getReceives: '/tzjrw/receive/getReceives',
    // 查看接收到的通知详情
    getDetail: '/tzjrw/receive/getDetail',
  },
  // 查看已读未读
  ckydwdUrls: {
    // 分页查询已发送的通知
    getMessages: '/tzjrw/message/getMessages',
    // 分页查询已读未读用户
    findPageReadOrUnread: '/tzjrw/message/findPageReadOrUnread',
  },
  userUrls: {
    getUsers: '/tzjrw/user/getUsers',
  },
  fileUrls: {
    downloadFile: '/file/files/downloadFile',
    uploadFile: '/file/files/uploadFile',
  },
  /**
   * 我的成绩录入任务url
   */
  WdcjlrrwUrl: {
    queryInfo: '/tzjrw/score/getJxbs',
    findData: '/tzjrw/score/findAll',
  },
};
